<template>
  <div class="signin">
    <Particles id="tsparticles" :options="particlesConfig" />
    <Login />
    <div class="signInFooter">
      <div class="signInFooterLogo">
        <img src=".././assets/22.png" />
      </div>
      <div class="tooltip-container" style="position: absolute; right: 20px">
        <v-btn> O Нас </v-btn>
        <div class="tooltip-content">
          <p>
            Версия: 1.1.9.7 <br />
            Производитель: ООО ООО «INVAN SOFT», Республика Узбекистан
            Программное обеспечение виртуальной кассы «INVAN POS»
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "../components/VSignin/Login.vue";

export default {
  name: "App",
  data() {
    return {
      particlesConfig: require("../particles/particles.json"),
    };
  },
  components: {
    Login,
  },
};
</script>
<style lang="scss">
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.tooltip-container {
  position: relative;
  &:hover {
    .tooltip-content {
      visibility: visible;
      opacity: 1;
      transition: 0.25s all ease;
      transition-delay: 0s;
      top: -60px;
    }
  }
}
.tooltip-content {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  background: #000000;
  left: -440px;
  top: -5px;
  padding: 0 0px;
  margin: 15px;
  font-size: 15px;
  width: 500px;
  transition: 0.25s all ease;
  transition-delay: 0.25s;
  z-index: 2;
  color: #ffffff;
}
</style>